import { Icon } from "@iconify/react";
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const SignInLayer = () => {
  const { login } = useAuth();
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    // Force pure white background on mount
    const originalBg = document.body.style.backgroundColor;
    document.body.style.backgroundColor = 'white';
    return () => {
      // Restore on unmount
      document.body.style.backgroundColor = originalBg;
    };
  }, []);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/");
    } catch (err) {
      if (err.code === 'ECONNABORTED' || err.message?.includes('timeout')) {
        setError("Connection timed out. The server may be slow or unreachable. Please try again.");
      } else if (err.message === 'Network Error' || !err.response) {
        setError("Cannot reach server. Check your connection and try again.");
      } else {
        setError(err.response?.data?.message || "Invalid email or password");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className='auth d-flex flex-wrap' style={{ background: 'white', minHeight: '100vh' }}>
      <div className='auth-left d-lg-block d-none p-48' style={{ background: 'white', flex: 1 }}>
        <div className="d-flex align-items-center justify-content-center h-100" style={{ background: 'white' }}>
          <img
            src='assets/cybersecurity-engineer-illustration-2025-10-20-04-38-49-utc.gif'
            alt='auth side bg'
            className="w-100 h-100 object-fit-contain"
          />
        </div>
      </div>
      <div className='auth-right py-32 px-24 d-flex flex-column justify-content-center border-start border-neutral-200' style={{ background: 'linear-gradient(180deg, #0466c8 0%, #0353a4 100%)' }}>
        <div className='max-w-464-px mx-auto w-100'>
          <div className="text-center">
            <Link to='/' className='mb-40 max-w-290-px d-block mx-auto'>
              <img src='assets/l.png' alt='logo' className="mx-auto" />
            </Link>
            <h4 className='mb-12 text-white'>SIGN IN</h4>
            <p className='mb-32 text-blue-100 text-lg' style={{ color: '#e0f2fe' }}>
              Welcome back! Please enter your details
            </p>
          </div>

          {error && (
            <div
              className="alert py-12 px-16 mb-24 radius-12 d-flex align-items-center gap-2"
              style={{ backgroundColor: 'rgba(255, 191, 0, 0.1)', border: '1px solid rgba(255, 191, 0, 0.4)', color: '#ffbf00' }}
            >
              <Icon icon="solar:danger-triangle-bold" className="text-xl" />
              <span className="fw-medium">{error}</span>
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className='icon-field mb-16'>
              <span className='icon top-50 translate-middle-y' style={{ color: '#fff', zIndex: 5 }}>
                <Icon icon='mage:email' />
              </span>
              <input
                type='email'
                className='form-control h-56-px radius-12 text-white login-input'
                style={{ backgroundColor: 'rgba(255, 255, 255, 0.1)', border: '1px solid rgba(255, 255, 255, 0.2)', transition: 'all 0.3s', color: 'rgba(255, 255, 255, 0.9)' }}
                placeholder='Email'
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className='position-relative mb-20'>
              <div className='icon-field'>
                <span className='icon top-50 translate-middle-y' style={{ color: '#fff', zIndex: 5 }}>
                  <Icon icon='solar:lock-password-outline' />
                </span>
                <input
                  type={showPassword ? 'text' : 'password'}
                  className='form-control h-56-px radius-12 text-white login-input'
                  style={{ backgroundColor: 'rgba(255, 255, 255, 0.1)', border: '1px solid rgba(255, 255, 255, 0.2)', transition: 'all 0.3s', color: 'rgba(255, 255, 255, 0.9)' }}
                  id='your-password'
                  placeholder='Password'
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
              <span
                className='cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16'
                style={{ color: '#fff', fontSize: '20px', zIndex: 5 }}
                onClick={togglePasswordVisibility}
              >
                <Icon icon={showPassword ? "solar:eye-broken" : "solar:eye-closed-broken"} />
              </span>
            </div>
            <div className=''>
              <div className='d-flex justify-content-between gap-2'>
                <div className='form-check style-check d-flex align-items-center'>
                  <input
                    className='form-check-input border border-white-50 bg-transparent'
                    style={{ borderColor: 'rgba(255, 255, 255, 0.4)' }}
                    type='checkbox'
                    defaultValue=''
                    id='remeber'
                  />
                  <label className='form-check-label text-white-50' style={{ color: 'rgba(255, 255, 255, 0.8)' }} htmlFor='remeber'>
                    Remember me{" "}
                  </label>
                </div>
              </div>
            </div>
            <button
              type='submit'
              className='btn btn-white text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32'
              style={{ backgroundColor: 'white', color: '#0466c8', fontWeight: '700', border: 'none' }}
              disabled={loading}
            >
              {loading ? "Signing In..." : "Sign In"}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default SignInLayer;
